import { Expose } from 'class-transformer';

export class TextProps {
  @Expose()
  text!: string | null;
}
